function convertToCurrencyOfPrice(amount) {
  return "$" + (amount / 100).toFixed(2);
}

let allLifestyleSelect = document.querySelectorAll(".lifestyleVariantOptions");

allLifestyleSelect.forEach((each) => {
  each.addEventListener("change", (event) => {
    let parentCLP = each.closest(".custom-lifestyle-product");
    let productHandle = each.dataset.handle;

    fetch("/products/" + productHandle + ".js")
      .then((response) => response.json())
      .then((data) => {
        let productVariants = data.variants;
        // console.log("event",event)
        parentCLP.querySelector(".quickAddBtn").dataset.atc =
          event.target.value;
        parentCLP.querySelector(".quickAddBtn").dataset.selection =
          event.target.selectedOptions[0].innerText;

        productVariants.forEach((eachVariant) => {
          let {
            name: titleOfVariant,
            id,
            price,
            compare_at_price,
            featured_image: { src: srcOfVariant },
          } = eachVariant;

          if (id == event.target.value) {
            if (
              /pedal commander/i.test(titleOfVariant) &&
              !/pedal commander®/i.test(titleOfVariant)
            ) {
              titleOfVariant = titleOfVariant.replace(
                /pedal commander/gi,
                (match) => {
                  return (
                    match.charAt(0).toUpperCase() +
                    match.slice(1).toLowerCase() +
                    "®"
                  );
                }
              );
            }

            parentCLP.querySelector(".clp-title").innerHTML = titleOfVariant;

            parentCLP.querySelector(".clp-price").innerHTML =
              convertToCurrencyOfPrice(price);
            if (parentCLP.querySelector(".clp-price-before")) {
              parentCLP.querySelector(".clp-price-before").innerHTML =
                convertToCurrencyOfPrice(compare_at_price);
            }
            if (srcOfVariant) {
              parentCLP.querySelector(".clp-image").src = srcOfVariant;
              parentCLP.querySelector(".clp-image").srcset = srcOfVariant;
            }
          }
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });
});

const quickAddButtons = document.querySelectorAll(".quickAddBtn");

quickAddButtons.forEach((button) => {
  button.addEventListener("click", (e) => {
    const loader = button.querySelector(".loading-icon");
    const text = button.querySelector(".text");
    loader.classList.remove("hidden");
    text.style.opacity = 0;

    const drawer = document.querySelector("custom-cart-drawer");

    const observer = new MutationObserver(() => {
      if (drawer.style.visibility === "visible") {
        loader.classList.add("hidden");
        text.style.opacity = 1;
        observer.disconnect();
      }
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ["style"] });
  });
});
